var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"animation10interface"}},[_c('lottie',{attrs:{"options":_vm.defaultOptions,"autoplay":true,"lottiespeed":0.1,"loop":false,"height":180,"width":260},on:{"animCreated":_vm.handleAnimation}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }